<template>
  <CreateAccount />
</template>

<script lang="ts">
import CreateAccount from "@/components/Account/create/CreateAccount.vue";
import { defineComponent } from "vue";

const componentName = "AccountSecurityRoute";

export default defineComponent({
  name: componentName,
  components: { CreateAccount },
});
</script>
